<script setup>
useUtmAttributionCapture()
</script>
<template>  
  <main>
    <NuxtPage />
  </main>
</template>